import { ReactComponent as Calendar } from "../../../../assets/utils/images/svgs/calendar-gray.svg";
import { ReactComponent as Settings } from "../../../../assets/utils/images/svgs/setting-gray.svg";
import { ReactComponent as Functies } from "../../../../assets/utils/images/svgs/db-gray.svg";
import { ReactComponent as CalendarCheck } from "../../../../assets/utils/images/svgs/calendar-check.svg";
import { ReactComponent as Employee } from "../../../../assets/utils/images/svgs/employee.svg";
import { ReactComponent as Profile } from "../../../../assets/utils/images/svgs/profiel-icon.svg";
import { ReactComponent as Clock } from "../../../../assets/utils/images/svgs/HistoryClock.svg";
import { ReactComponent as Historie } from "../../../../assets/utils/images/svgs/historie-doc.svg";
import { ReactComponent as CheckGray } from "../../../../assets/utils/images/svgs/Ok-gray.svg";
import { ReactComponent as HelpGray } from "../../../../assets/utils/images/svgs/Help-gray.svg";
import { ReactComponent as CrossGray } from "../../../../assets/utils/images/svgs/Cross-gray.svg";
import { BsCheckCircle } from "react-icons/bs";
import { BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../assets/utils/images/svgs/Cross.svg";

import Controlscherm from "../PlanscreenView/Controlscherm";
import Instellingen from "./Instellingen";
import Profiel from "./Profiel.js";
import Documenten from "./Documenten";
import Algemeen from "./Algemeen";
import FunctiesPage from "./Functies";
import Beschikbaarheid from "./Beschikbaarheid";
import Matchcodes from "./Matchcodes";
import Urenoverzicht from "./Urenoverzicht";

export function getUserTabs(pathname, isSubstitutor,disable) {
	const segment = getTabValue(pathname);

	const limitedUserTabs = {
		Profiel: "profiel",
		Algemeen: "algemeen",
	};

	const tabConfigs = {
		verzoeken: {
			Controlscherm: "controlescherm",
			Algemeen: "algemeen",
			Personalia: "personalia",
			Besturen: "besturen",
			Profiel: "profiel",
			Instellingen: "instellingen",
			Documenten: "documenten",
			Functies: "functies",
			Beschikbaarheid: "beschikbaarheid",
			Matchcodes: "matchcode",
			Historie: "historie",
			MinMax: "minMax",
			Urenoverzicht: "urenoverzicht",
		},
		gebruikers:isSubstitutor && !disable
			? {
				...limitedUserTabs,
				Instellingen: "instellingen",
				Documenten: "documenten",
				Functies: "functies",
				Beschikbaarheid: "beschikbaarheid",
				Matchcodes: "matchcodes",
				Urenoverzicht: "urenoverzicht",
			}
			: limitedUserTabs,
	};

	return tabConfigs[segment] || {};
}


export function getTabValue(pathname) {
	const pathSegments = pathname.split("/").filter(Boolean);
	return pathSegments[0];
}

export const getActiveTab = (userTabs, tabState) => {
	switch (tabState) {
		case userTabs.Personalia:
			return <>Personalia</>;
		case userTabs.Besturen:
			return <>Besturen</>;
		case userTabs.Historie:
			return <>Historie</>;
		case userTabs.MinMax:
			return <>MinMax</>;
		case userTabs.Profiel:
			return (
				<Profiel>
					<Profiel.Contactgegevens />
					<Profiel.Wrapper>
						<Profiel.Rollen />
						<Profiel.LaatsteLogin />
					</Profiel.Wrapper>
					<Profiel.Verzoeken />
					<Profiel.SendSMS />
				</Profiel>
			);
		case userTabs.Algemeen:
			return (
				<Algemeen>
					<Algemeen.Wrapper>
						<Algemeen.PersonalDetails />
						<Algemeen.Subwrapper>
							<Algemeen.ContactDetails />
							<Algemeen.Photo />
							<Algemeen.LoginDetails />
							<Algemeen.Role />
							
						</Algemeen.Subwrapper>
					</Algemeen.Wrapper>
				</Algemeen>
			);
		case userTabs.Instellingen:
			return (
				<Instellingen>
					<Instellingen.Wrapper>
						<Instellingen.Institution />
						<Instellingen.Arrangement />
						<Instellingen.Salary />
						<Instellingen.Remark />
						<Instellingen.Contracts />
						<Instellingen.Log />
					</Instellingen.Wrapper>

					<Instellingen.Footer />
				</Instellingen>
			);
		case userTabs.Documenten:
			return (
				<Documenten>
					<Documenten.Wrapper>
						<Documenten.DocTable />
						<Documenten.SubstituteTable />
					</Documenten.Wrapper>
					<Documenten.Footer />
				</Documenten>
			);
		case userTabs.Functies:
			return (
				<FunctiesPage>
					<FunctiesPage.Screen>
						<FunctiesPage.Wrapper>
							<FunctiesPage.Features />
							<FunctiesPage.Gym />
						</FunctiesPage.Wrapper>
						<FunctiesPage.Footer />
					</FunctiesPage.Screen>
				</FunctiesPage>
			);
		case userTabs.Beschikbaarheid:
			return <Beschikbaarheid />;
		case userTabs.Matchcodes:
			return (
				<Matchcodes>
					<Matchcodes.Wrapper>
						<Matchcodes.Tables />
					</Matchcodes.Wrapper>
					<Matchcodes.Footer />
				</Matchcodes>
			);
		case userTabs.Urenoverzicht:
			return (
				<Urenoverzicht>
					<Urenoverzicht.Wrapper>
						<Urenoverzicht.PeriodOverview />
						<Urenoverzicht.MonthlyOverview />
						<Urenoverzicht.WeeklyOverview />
					</Urenoverzicht.Wrapper>
					<Urenoverzicht.Footer />
				</Urenoverzicht>
			);
		case userTabs.Controlscherm:
			return <Controlscherm />;
		default:
				return (
				<Algemeen>
					<Algemeen.Wrapper>
						<Algemeen.PersonalDetails />
						<Algemeen.Subwrapper>
							<Algemeen.ContactDetails />
							<Algemeen.Photo />
							<Algemeen.LoginDetails />
							<Algemeen.Role />
						</Algemeen.Subwrapper>
					</Algemeen.Wrapper>
				</Algemeen>
			);
	}
};

export const getTabs = () => { };

export const tabsList = [
	{ name: "Controlescherm", key: "controlescherm", icon: <Calendar /> },
	{ name: "Personalia", key: "personalia", icon: <Employee /> },
	{ name: "Besturen", key: "besturen", icon: <Employee /> },
	{ name: "Profiel", key: "profiel", icon: <Profile /> },
	{ name: "Algemeen", key: "algemeen", icon: <Settings /> },
	{ name: "Instellingen", key: "instellingen", icon: <Settings /> },
	{ name: "Docs", key: "docs", icon: <Settings /> },
	{ name: "Functies", key: "functies", icon: <Functies /> },
	{ name: "Beschikbaarheid", key: "beschikbaarheid", icon: <CalendarCheck /> },
	{ name: "Matchcodes", key: "matchcodes", icon: <CalendarCheck /> },
	{ name: "Matchcode", key: "matchcode", icon: <CalendarCheck /> },
	{ name: "Historie", key: "historie", icon: <Historie /> },
	{ name: "Min/Max", key: "minMax", icon: <CalendarCheck /> },
	{ name: "Urenoverzicht", key: "urenoverzicht", icon: <Clock /> },
	{ name: "Documenten", key: "documenten", icon: <Settings /> },
];

export function getTabsMenus(userTabs = {}) {
	const tabKeys = Object.values(userTabs);

	return tabsList.filter((tab) => tabKeys.includes(tab.key));
}

export const debounce = (fn, delay) => {
	let timeoutId;
	return (...args) => {
		if (timeoutId) clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			fn(...args);
		}, delay);
	};
};

export const GENERATE_PASSWORD = "GENERATE_PASSWORD";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";

export const roleColors = ["#FF0000", "#3AC47D", "#AD00FF"];

export const userRoles = {
	Coordinator: "coordinator",
	Melder: "melder",
	Vervanger: "vervanger",
};

export const iconSwitch = (param, type = "", isLocked = false) => {
	switch (param) {
		case "+":
			if (type === "bestuur") {
				if (isLocked) return <CheckGray />;
				else return <BsCheckCircle color="#39A825" fontSize={"18px"} />;
			} else return <CheckGray />;
		case "?":
			if (type === "bestuur") {
				if (isLocked) return <HelpGray />;
				else return <BsQuestionCircle color="#F2983E" fontSize={"18px"} />;
			} else return <HelpGray />;
		case "-":
			if (type === "bestuur") {
				if (isLocked) return <CrossGray />;
				else return <CrossIcon fontSize={"18px"} />;
			} else return <CrossGray />;
		default:
			return "--";
	}
};

export const downloadBase64File = (file, fileName) => {
	const [prefix, data] = file.split(",");
	const mimeType = prefix.match(/:(.*?);/)[1];

	const binaryData = atob(data);
	const byteNumbers = new Array(binaryData.length);
	for (let i = 0; i < binaryData.length; i++) {
		byteNumbers[i] = binaryData.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);

	const blob = new Blob([byteArray], { type: mimeType });
	const blobUrl = URL.createObjectURL(blob);

	const link = document.createElement("a");
	link.href = blobUrl;
	link.download = fileName || "downloaded_file";
	document.body.appendChild(link);

	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(blobUrl);
};
